var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 78,
    viewBox: "0 0 63 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3868 74C34.9833 74 38.5445 73.2918 41.8672 71.9153C45.1899 70.5394 48.2088 68.5221 50.752 65.979C53.2951 63.4358 55.3124 60.4167 56.6889 57.0936C58.0653 53.7711 58.7735 50.2099 58.7735 46.6134V31.3863C58.7741 24.6584 56.2978 18.1658 51.8173 13.1468M4 37.4659V46.6131C3.99819 52.0044 5.58761 57.2765 8.56921 61.768C11.5508 66.2599 15.7918 69.772 20.7607 71.8638M45.08 7.66908C38.7899 4.03752 31.3147 3.05339 24.299 4.93316C17.2832 6.81291 11.3015 11.4026 7.66972 17.6926C6.17424 20.2754 5.11913 23.089 4.54763 26.0182M28.5384 19.8833C30.553 19.4651 32.6357 19.5044 34.6331 19.9982C36.6305 20.4921 38.4915 21.428 40.079 22.7369C41.6665 24.0458 42.94 25.6943 43.8055 27.5609C44.6711 29.4275 45.1066 31.4646 45.08 33.5219V42.3405M41.5744 53.8433C39.7107 55.9193 37.2575 57.3762 34.5429 58.0198C31.8284 58.6634 28.9821 58.4624 26.385 57.4436C23.7879 56.4248 21.5638 54.6374 20.0104 52.3202C18.4571 50.0029 17.6486 47.2665 17.6931 44.4771V33.5223C17.6827 31.6412 18.0554 29.7775 18.7886 28.045M31.3868 34.1255V43.2726",
    stroke: "#00C389",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon3);
export default __webpack_public_path__ + "static/media/privacy_icon_3.eead590d4d566fae9b042cb678b41262.svg";
export { ForwardRef as ReactComponent };